import React from 'react';

import {SkeletonItem} from 'src/components/skeleton';

import {FormSection} from '@pb/kit-component-form-section';
import {Group, Item} from '@pb/kit-component-group';

export const ProductAccessSummarySectionSkeleton = () => (
    <FormSection
        headline="Product Access Summary"
        info={() => (
            <Item grow={1}>
                <Group justify="space-between" alignItems="center">
                    <SkeletonItem width={200} height={28}/>
                    <SkeletonItem width={60} height={28}/>
                </Group>
            </Item>
        )}>
        <Group direction="v" gap="l">
            <Group direction="v" gap="s">
                <Group gap="s" alignItems="center">
                    <SkeletonItem circle={true} width={8} height={8}/>
                    <SkeletonItem width={50} height={16}/>
                    <SkeletonItem width={100} height={18}/>
                </Group>
                <Group gap="m" alignItems="center">
                    <SkeletonItem width={180} height={14}/>
                    <SkeletonItem width={80} height={4}/>
                    <SkeletonItem width={70} height={14}/>
                </Group>
            </Group>
            <Group direction="v" gap="s">
                <Group gap="s" alignItems="center">
                    <SkeletonItem circle={true} width={8} height={8}/>
                    <SkeletonItem width={50} height={16}/>
                    <SkeletonItem width={120} height={18}/>
                </Group>
                <Group gap="m" alignItems="center">
                    <SkeletonItem width={180} height={14}/>
                    <SkeletonItem width={80} height={4}/>
                    <SkeletonItem width={70} height={14}/>
                </Group>
            </Group>
            <Group direction="v" gap="s">
                <Group gap="s" alignItems="center">
                    <SkeletonItem circle={true} width={8} height={8}/>
                    <SkeletonItem width={60} height={16}/>
                    <SkeletonItem width={90} height={18}/>
                </Group>
                <Group gap="m" alignItems="center">
                    <SkeletonItem width={180} height={14}/>
                    <SkeletonItem width={80} height={4}/>
                    <SkeletonItem width={70} height={14}/>
                </Group>
            </Group>
        </Group>
    </FormSection>
);
